import styled from "@emotion/styled";
import { Box } from "@mui/system";

export const TemplateMessageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
